import Vue from 'vue';
import toastService from '@services/Toast';

Vue.prototype.$toast = toastService;
